import { PatientType } from "types";

const IMAGE_BASE_URL = `${process.env.PUBLIC_URL}/images/patient-picker`;
const DISCLAIMER =
  "Our service is not intended for emergency situations. If you have an urgent medical concern, please call a doctor or an emergency hotline, or go to the nearest hospital.";

const OPTIONS: { value: PatientType; label: string; image: string }[] = [
  {
    value: "self",
    label: "Myself",
    image: `${IMAGE_BASE_URL}/self.jpg`,
  },
  {
    value: "child",
    label: "My child",
    image: `${IMAGE_BASE_URL}/child.jpg`,
  },
  {
    value: "parent",
    label: "My parent",
    image: `${IMAGE_BASE_URL}/parent.jpg`,
  },
  {
    value: "others",
    label: "Someone\nelse",
    image: `${IMAGE_BASE_URL}/others.jpg`,
  },
];

export { DISCLAIMER, OPTIONS };
